import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../base-form';
import { ProductosApiService } from '../../../../../service/api/productos-api';
import { ProductosModel } from 'src/app/models/productos/productos.model';
import { ProductosSimpleFormDefinition } from './form-control/form-definition';

@Component({
    selector: 'app-productos-simple-form',
    standalone: false,
    templateUrl: './productos-simple-form.component.html',
    styleUrls: ['./productos-simple-form.component.scss']
})
export class ProductosSimpleFormComponent extends BaseForm<ProductosModel> implements OnInit {
    public override model: ProductosModel = { nombre: '', materia_activa: '' };
    public form!: ProductosSimpleFormDefinition;
    public reactiveFormRecordId = '';

    constructor(
        public dashboardEvents: DashboardService,
        public productosApi: ProductosApiService,
        public override router: Router,
        public override route: ActivatedRoute,
    ) {
        super(
            route,
            router,
            dashboardEvents,
            productosApi.productos.PUT,
            productosApi.productos.POST,
            'productos',
            'Actualizar Fitosanitario',
            'Crear Fitosanitario'
        );
    }

    public ngOnInit(): void {
        this.softInit(this.getType());
        this.model = this.initializeHostModel({ ...this.model, ...this.getModel() });
        this.reactiveFormRecordId = this.resolveReactiveFormRecordId(this.model);
        this.form = new ProductosSimpleFormDefinition(this.getType(), this.model);
    }

    public override goBack(): void {
        this.router.navigate(['dashboard', 'productos-s']);
    }
}
